module.exports = __webpack_public_path__ + "static/media/45GovernorsPool.15287edb.jpg";